import { CLIENT_ID } from 'shared/constants';
import { AppPermission, UserInfo } from 'shared/types';

export const getPermissionsFromClaims = (InsightClaims: string) =>
    InsightClaims.split(' ').filter(p => p.startsWith(CLIENT_ID)) as AppPermission[];

export const checkPermissions = (InsightClaims: string) => (...permissions: AppPermission[]) =>
    permissions.every(permission => getPermissionsFromClaims(InsightClaims).includes(permission));

export const getUserInfoFromIdClaims = ({
    given_name,
    family_name,
    name,
    InsightClaims,
}: Record<string, string>): UserInfo => ({
    firstName: given_name,
    lastName: family_name,
    email: name,
    displayName: `${given_name} ${family_name}`,
    insightClaims: InsightClaims,
});
